<template lang="pug">
modal-vue(
  :modal_id="'links_modal'"
  :content_loaded="links_loaded"
  :size_modal="'modal-lg'"
  :auto-close-enabled="true"
  :visible.sync="visible"
)
  template(v-slot:header)
    span.align-self-center.mr-auto(data-cy="modal_title")
      | {{ modalTitle }}

  template(v-slot:body)
    div.error_message(
      v-if="links_load_error"
      data-cy="error_message"
    )
      | {{ t('components.documents.modal_links.load_error') }}
    div(v-else)
      link-vue(
        v-for="link in links"
        :key="link.id"
        :link="link"
      )

  template(v-slot:footer)
    button.btn.btn-secondary(
      type="button"
      @click="hide_modal"
    )
      | {{ t('components.documents.modal_links.close') }}

</template>

<script>
import mixins from 'common/mixins'

export default {
  name: 'modal-links-vue',
  mixins: [mixins.translate, mixins.requests],
  components: {
    'modal-vue': () => import(/* webpackChunkName: "[request]" */ 'components/Modal'),
    'link-vue': () => import(/* webpackChunkName: "[request]" */ 'components/documents/Link')
  },
  data() {
    return {
      links_loaded: false,
      links_load_error: false,
      links: [],
      visible: false
    }
  },
  computed: {
    modalTitle() {
      return this.links_loaded
        ? this.t('components.documents.modal_links.title')
        : this.t('components.documents.modal_links.loading')
    }
  },
  methods: {
    async load_links(document_ids) {
      this.reset_modal()
      this.show_modal()
      await this.fetch_links(document_ids)
    },
    reset_modal() {
      this.links_loaded = false
      this.links_load_error = false
    },
    show_modal() {
      this.visible = true
    },
    hide_modal() {
      this.visible = false
    },
    async fetch_links(documentIds) {
      const params = new URLSearchParams()
      documentIds.forEach(docid => {
        params.append('ids[]', docid)
      })

      const url = `/base/${gon.current_app}/documents?${params}`
      const response = await fetch(url)

      if (!response.ok) {
        this.set_links_error()
        return
      }

      const jsonDocumentData = await response.json()
      if (documentIds.some(id => id.includes('#'))) {
        this.addArticles(documentIds, jsonDocumentData)
      }

      this.removeMainDocs(jsonDocumentData)

      if (this.isSingleDocumentWithoutArticles(jsonDocumentData)) {
        this.$emit('links-single-document-found', { documentId: jsonDocumentData[0].id })
        this.hide_modal()
      } else {
        this.set_links_data(jsonDocumentData)
      }
    },
    addArticles(docids, data) {
      docids.forEach(docid => {
        const parts = docid.split('#art')
        if (parts.length != 2) return

        const documentId = parseInt(parts[0])
        const articleNumber = parts[1].startsWith('_')
          ? parseInt(parts[1].substring(1))
          : parseInt(parts[1])

        const document = data.find(item => item.id === documentId)
        if (!document) return

        if (!document.articles) {
          document.articles = []
        }

        if (!document.articles.includes(articleNumber)) {
          document.articles.push(articleNumber)
        }
      })
    },
    set_links_data(data) {
      this.links_loaded = true
      this.links = data
    },
    set_links_error(){
      this.links_loaded = true
      this.links_load_error = true
    },
    removeMainDocs(data) {
      const mainDocIds = new Set()

      data.forEach(doc => {
        if (doc.descriptores && doc.descriptores.documentoprincipal) {
          mainDocIds.add(doc.descriptores.documentoprincipal)
        }
      })

      if (mainDocIds.size === 0) {
        return
      }

      const filteredData = data.filter(doc => !mainDocIds.has(doc.id))
      data.length = 0
      data.push(...filteredData)
    },
    isSingleDocumentWithoutArticles(documentData) {
      return documentData.length === 1 && documentData[0].id && !documentData[0].articles
    }
  }
}
</script>
